/** @graphql agg **/
import gql from 'graphql-tag';
import { graphql } from 'react-relay';

export const ContentIdByReferenceIdQuery = gql`
	query ContentIdByReferenceIdQuery($id: String!) {
		contentIdByReferenceId(referenceId: $id)
	}
`;

export const ContentIdByReferenceIdQuery_Relay = graphql`
	query ContentIdByReferenceIdQuery($id: String!) {
		contentIdByReferenceId(referenceId: $id)
	}
`;
